<template>
    <main>

    </main>
</template>

<script>
import store from "../../store";
import axios from "axios";
export default {
    data: () => ({
        store: store,
    }),
    watch: {
    },
    created: async function() {
        var config = {
            method: "post",
            url: `${this.store.state.baseURL}deletion`,
            headers: {
                "Content-Type": "application/form-data;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
                Accept: "*/*"
            }
        };
        await axios(config);

    },
};
</script>
